// Breadcrumb for Watch Tower Mobile Views
import classNames from "classnames";
import { FaFolder } from "react-icons/fa";
import { HiArrowLeft } from "react-icons/hi";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import "./style.scss";
interface Props {
  className?: string;
  projectName?: string;
  currentView: string;
  onBack(): void;
  pageName: string;
}
export const BreadcrumbWT = ({
  currentView,
  className,
  onBack,
  projectName = "",
  pageName,
}: Props) => {
  return (
    <div className={classNames("breadcrumb-wt", className)}>
      {currentView !== "project" && (
        <div className="breadcrumb-wt__back" onClick={onBack}>
          <HiArrowLeft size={18} />
        </div>
      )}
      <div className="d-flex flex-column">
        <div className="breadcrumb-wt__heading">WatchTower</div>
        <div className="d-flex my-auto">
          <div className="d-flex me-1">
            <FaFolder color="#F79C05" size={18} className="my-auto" />
          </div>
          <div className={`breadcrumb-wt__title ${projectName ? "" : "large"}`}>
            {pageName}
          </div>
        </div>
        {projectName && (
          <div className="d-flex ms-3 my-auto">
            <MdOutlineArrowForwardIos
              size={14}
              color="#919191"
              className="my-auto ms-1"
            />
            <div className="ms-2 breadcrumb-wt__name">{projectName}</div>
          </div>
        )}
      </div>
    </div>
  );
};
